import React from 'react';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import { Button, ButtonIconPosition, ButtonSize, ButtonVariant } from '@amzn/stencil-react-components/button';
import { H1, H2, Label, Text } from '@amzn/stencil-react-components/text';
import { PageContainer } from '@amzn/stencil-react-components/page';
import { Col, Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { Table, TableSpacing } from '@amzn/stencil-react-components/table';
import { Avatar, AvatarText } from '@amzn/stencil-react-components/avatar';
import {
    FormWrapper,
    InputWrapper,
    Select,
    TextArea,
    TextAreaWithRecommendedLength
} from '@amzn/stencil-react-components/form';
import { Modal, ModalContent } from '@amzn/stencil-react-components/modal';
import { FederateData, PageProps } from '../models/FederateData';
import {
    getColumnsVariableStaffing,
    getColumnsVariableStaffingChangeLog,
    getRowAttributesCLForVS,
    renderCardForChanglelogVS,
    renderCardForRowVS,
    VSTableData
} from '../models/VSTableData';
import { HR2021Theme } from '@amzn/stencil-react-theme-default';
import AuthService from '../services/AuthService';
import VariableStaffingState from '../models/VariableStaffingState';
import CustomHeader, { ButtonWithTooltip } from '../components/CustomHeader';
import CustomBackToTop from '../components/CustomBackToTop';
import CustomFooter from '../components/CustomFooter';
import { containsLdapElement, containsLdapElementForViewOnly, LDAP } from '../models/LDAP';
import { AppConfig } from '../models/AppConfig';
import { AwsClient } from 'aws4fetch';
import { getCredentials } from '../services/aws.service';
import errorHandling from '../components/ErrorHandler';
import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner';
import { Spinner } from '@amzn/stencil-react-components/spinner';
import CustomError from '../models/CustomError';
import SignedOut from './SignedOut';
import Forbidden from './Forbidden';
import { IconArrowRight, IconCross, IconDownload, IconReset, IconSize } from '@amzn/stencil-react-components/icons';
import { cssPropertiesTable } from '../models/TableCustomCSS';
import { modalInstructionsVS } from '../models/Instructions';
import { Redirect } from 'react-router-dom';
import '../App.css';
import { MainWithSkipLink } from '@amzn/stencil-react-components/a11y';
import { ScreenReaderOnly } from '@amzn/stencil-react-components/screen-reader-only';
import { tabs } from '../models/CustomTabs';
import { TabBar, TabPanel, TabsLayout, TabSwitcher } from '@amzn/stencil-react-components/tabs';
import { Expander } from '@amzn/stencil-react-components/expander';
import { PopupDateRangePicker } from '@amzn/stencil-react-components/date-picker';
import { Pagination } from '@amzn/stencil-react-components/pagination';
import { convertToTimestamp, isBlank } from '../services/FilterServices';
import { TooltipAlignment, TOOLTIP_POSITION } from '@amzn/stencil-react-components/tooltip';


var FileSaver = require('file-saver');
const Diff = require('diff');
const appConfig: AppConfig = require('../components/config.json')[`${process.env.REACT_APP_ENVIRONMENT}`];
const authService: AuthService = new AuthService();

export default class VSAMER extends React.Component<PageProps, VariableStaffingState> {
    showNumberOfRows: boolean = false;
    awsFetchClient: AwsClient | undefined;
    promiseAwsFetchClient: Promise<AwsClient> = getCredentials();
    configuration: string = '';
    configurationSelected: string = '';
    federateToken: FederateData = authService.isTokenPresent() ? authService.getDecodedToken() : window.location.href = '/auth';
    totalCount: number = 0;
    auditFilterURI: string = '';
    filters: string[] = [];
    valueOfAT: string[] = [];
    isReadOnly: boolean = containsLdapElementForViewOnly(this.federateToken.LDAPGROUP, LDAP[3].toString());

    state: VariableStaffingState = {
        fetchedDataForDropdown: [],
        fetchedDataForTableRows: [],
        isOpen: false,
        loading: true,
        isPostError: '',
        isPostSuccess: false,
        readyToRedirect: false,
        fetchedChangelogData: [],
        tabValue: tabs[0],
        selectedPage: 1,
        startDate: '',
        endDate: '',
        isExpanded: false
    };

    tableData: VSTableData = {
        ConfigurationId: '',
        Frontline: '',
        Vendor1: '',
        Vendor2: '',
        comment: ''
    };

    updatedTableData: VSTableData = {
        ConfigurationId: '',
        Frontline: '',
        Vendor1: '',
        Vendor2: '',
        comment: ''
    };

    setLoadingValue() {
        this.setState({ loading: true });
    }

    componentDidMount() {
        document.title = ' Variable Staffing ';
        this.getTableDataForChangelog(false, 1, this.state.startDate, this.state.endDate);
        if (authService.isTokenPresent()) {
            this.promiseAwsFetchClient.then(async (awsClient) => {
                  this.awsFetchClient = awsClient;
                  try {
                      await this.awsFetchClient.fetch(
                        appConfig.apigUri + 'product?name=VariableStaffing',
                        {
                            method: 'GET',
                            headers: {
                                'token': authService.getToken()
                            }
                        }
                      ).then((promiseResponse) => {
                            return promiseResponse.json();
                        }
                      ).then((fetchedData) => {
                          if (fetchedData.Error !== undefined) {
                              return <Redirect to='/SignedOut' />;
                          }
                          this.setState({ fetchedDataForDropdown: fetchedData, loading: false });
                      }).catch(async (rejectedPromiseObject) => {
                            errorHandling(rejectedPromiseObject);
                        }
                      );
                  } catch (error) {
                      errorHandling(error);
                      this.setState({ loading: false });
                  }
              }
            );
        } else {
            this.setState({ readyToRedirect: true });
        }
    }

    getTableData(value: String) {
        this.setLoadingValue();

        if (authService.isTokenPresent()) {
            this.promiseAwsFetchClient.then(async (awsClient) => {
                  this.awsFetchClient = awsClient;
                  try {
                      await this.awsFetchClient.fetch(
                        appConfig.apigUri + 'component?p_name=VariableStaffing&c_name=' + value.toString(),
                        {
                            method: 'GET',
                            headers: {
                                'token': authService.getToken()
                            }
                        }
                      ).then((promiseResponse) => {
                            return promiseResponse.json();
                        }
                      ).then((fetchedData) => {
                          if (fetchedData.Error !== undefined) {
                              return <Redirect to='/SignedOut' />;
                          }
                          this.setState({ fetchedDataForTableRows: fetchedData, loading: false });
                      });

                  } catch (error) {
                      errorHandling(error);
                      this.setState({ loading: false });
                  }
              }
            ).catch(async (rejectedPromiseObject) => {
                  errorHandling(rejectedPromiseObject);
              }
            );
        } else {
            this.setState({ readyToRedirect: true });
        }
    }

    updateTableData(tableData: VSTableData) {
        this.setLoadingValue();
        const body = {
            'ConfigurationId': this.tableData.ConfigurationId,
            'Frontline': Number(tableData.Frontline) as number,
            'prevFrontline': Number(this.tableData.Frontline) as number,
            'Vendor1': Number(tableData.Vendor1) as number,
            'prevVendor1': Number(this.tableData.Vendor1) as number,
            'Vendor2': Number(tableData.Vendor2) as number,
            'prevVendor2': Number(this.tableData.Vendor2) as number,
            'comment': tableData.comment,
            'user': this.federateToken.sub
        };

        if (authService.isTokenPresent()) {
            this.promiseAwsFetchClient.then(async (awsClient) => {
                  this.awsFetchClient = awsClient;
                  try {
                      await this.awsFetchClient.fetch(
                        appConfig.apigUri + 'component?p_name=VariableStaffing&c_name=' + this.configuration,
                        {
                            method: 'PATCH',
                            headers: {
                                'token': authService.getToken()
                            },
                            body: JSON.stringify(body)
                        }
                      ).then((promiseResponse) => {
                            return promiseResponse.json();
                        }
                      ).then((fetchedData) => {
                          if (fetchedData.Error !== undefined) {
                              throw new CustomError(fetchedData.Error);
                          }
                          this.configurationSelected = tableData.ConfigurationId;
                          this.setState({
                              fetchedDataForTableRows: fetchedData,
                              loading: false,
                              isPostSuccess: true,
                              isPostError: ''
                          });
                          this.updatedTableData = {
                              ConfigurationId: '',
                              Frontline: '',
                              Vendor1: '',
                              Vendor2: '',
                              comment: ''
                          };
                      });
                  } catch (error: any) {
                      errorHandling(error);
                      this.setState({ loading: false, isPostError: error.message, isPostSuccess: false });
                      this.updatedTableData = {
                          ConfigurationId: '',
                          Frontline: '',
                          Vendor1: '',
                          Vendor2: '',
                          comment: ''
                      };
                  }
              }
            ).catch(async (rejectedPromiseObject) => {
                  errorHandling(rejectedPromiseObject);
              }
            );
        } else {
            this.setState({ readyToRedirect: true });
        }
    }

    getTableDataForChangelog(isLoading: boolean, pageNumber: number, startDate: string | undefined, endDate: string | undefined) {
        if (isLoading) {
            this.setLoadingValue();
        }

        startDate = convertToTimestamp(startDate);
        endDate = convertToTimestamp(endDate);

        this.auditFilterURI = isBlank(startDate) ? isBlank(startDate) && !isBlank(endDate) ? '&end_timestamp=' + endDate : '' :
          this.auditFilterURI = isBlank(endDate) ? !isBlank(startDate) && isBlank(endDate) ? '&start_timestamp=' + startDate : '' :
            '&start_timestamp=' + startDate + '&end_timestamp=' + endDate;

        if (authService.isTokenPresent()) {
            this.promiseAwsFetchClient.then(async (awsClient) => {
                  this.awsFetchClient = awsClient;
                  try {
                      await this.awsFetchClient.fetch(
                        appConfig.apigUriAudit + 'audit_trails?name=VariableStaffing&page=' + pageNumber + this.auditFilterURI,
                        {
                            method: 'GET',
                            headers: {
                                'token': authService.getToken()
                            }
                        }
                      ).then((promiseResponse) => {
                            return promiseResponse.json();
                        }
                      ).then(async (fetchedData) => {
                          if (fetchedData.Error !== undefined) {
                              throw new CustomError(fetchedData.Error);
                          }

                          if (pageNumber === 1) {
                              this.totalCount = fetchedData.count;
                              fetchedData = fetchedData.results;
                          }

                          fetchedData = await fetchedData.filter((element: any) => element.diffText = (Diff.diffChars(element.PreviousState, element.CurrentState)));
                          fetchedData.filter((element: any): void | null => {
                              let str: string = '<pre style="line-height: 1.5em;font-size: 15px">';
                              element.diffText.filter((innerElement: any): void | null => {
                                  const screenReaderAction = innerElement.added ? '<span class="screen-reader"> Current characters </span>' : innerElement.removed ? '<span class="screen-reader"> Previous characters </span>' : '<span class="screen-reader"> Unchanged characters </span>';
                                  const backgroundColor = innerElement.added ? '#86dac9' : innerElement.removed ? '#f8a49e' : 'white';
                                  const action = innerElement.added ? 'ins' : innerElement.removed ? 'del' : 'span';
                                  str += (screenReaderAction + '<' + action + ' style="background-color:' + backgroundColor + ';">' + innerElement.value + '</' + action + '>');
                                  return null;
                              }, '');
                              str += '</pre>';
                              element.diffText = str;
                              return null;
                          }, '');

                          this.setState({ fetchedChangelogData: fetchedData, loading: false });
                      });
                  } catch (error) {
                      errorHandling(error);
                      this.setState({ loading: false });
                  }
              }
            ).catch(async (rejectedPromiseObject) => {
                  errorHandling(rejectedPromiseObject);
              }
            );
        } else {
            this.setState({ readyToRedirect: true });
        }
    }

    getChangelogCSV(isLoading: boolean, startDate: string | undefined, endDate: string | undefined) {
        if (isLoading) {
            this.setLoadingValue();
        }

        startDate = convertToTimestamp(startDate);
        endDate = convertToTimestamp(endDate);

        this.auditFilterURI = isBlank(startDate) ? isBlank(startDate) && !isBlank(endDate) ? '&end_timestamp=' + endDate : '' :
          this.auditFilterURI = isBlank(endDate) ? !isBlank(startDate) && isBlank(endDate) ? '&start_timestamp=' + startDate : '' :
            '&start_timestamp=' + startDate + '&end_timestamp=' + endDate;

        if (authService.isTokenPresent()) {
            this.promiseAwsFetchClient.then(async (awsClient) => {
                  this.awsFetchClient = awsClient;
                  try {
                      await this.awsFetchClient.fetch(
                        appConfig.apigUriAudit + 'audit_trails?name=VariableStaffing&page=1&is_csv_requested=true' + this.auditFilterURI,
                        {
                            method: 'GET',
                            headers: {
                                'token': authService.getToken()
                            }
                        }
                      ).then((promiseResponse) => {
                            return promiseResponse.json();
                        }
                      ).then(async (fetchedData) => {
                          if (fetchedData.Error !== undefined) {
                              throw new CustomError(fetchedData.Error);
                          }
                          this.setState({ loading: false });
                          FileSaver.saveAs(new Blob([fetchedData], { type: 'text/csv;charset=utf-8' }), 'VariableStaffing-' + new Date().toISOString().split('T')[0] +
                            '_' + new Date().toLocaleTimeString('en-GB') + '.csv');

                          // https://stackoverflow.com/questions/11336663/how-to-make-a-browser-display-a-save-as-dialog-so-the-user-can-save-the-conten

                      });
                  } catch (error) {
                      errorHandling(error);
                      this.setState({ loading: false });
                  }
              }
            ).catch(async (rejectedPromiseObject) => {
                  errorHandling(rejectedPromiseObject);
              }
            );
        } else {
            this.setState({ readyToRedirect: true });
        }
    }

    handleSubmit = (event: any) => {
        event.preventDefault();
        this.updateTableData(this.updatedTableData);
    };

    close = () => this.setState({ isOpen: false });

    checkValidEntry = () => {
        if (this.updatedTableData.Frontline === '' || this.updatedTableData.Vendor1 === '' || this.updatedTableData.Vendor2 === '') {
            alert('The % value can not be empty.');
            return true;
        }

        if (!Number.isFinite(Number(this.updatedTableData.Frontline)) || !Number.isFinite(Number(this.updatedTableData.Vendor1)) || !Number.isFinite(Number(this.updatedTableData.Vendor2))) {
            alert('The % value can not be string.');
            return true;
        }

        if (Number(this.updatedTableData.Frontline) < 0 || Number(this.updatedTableData.Vendor1) < 0 || Number(this.updatedTableData.Vendor2) < 0) {
            alert('The % value can not be negative.');
            return true;
        }

        if (this.updatedTableData.Frontline === this.tableData.Frontline && this.updatedTableData.Vendor1 === this.tableData.Vendor1 && this.updatedTableData.Vendor2 === this.tableData.Vendor2) {
            alert('No Changes were made, please make edits.');
            return true;
        }

        if (Number(this.updatedTableData.Frontline) + Number(this.updatedTableData.Vendor1) + Number(this.updatedTableData.Vendor2) !== 100) {
            alert('The sum of Front line %, Vendor1 % and Vendor2 % should be exactly hundred.');
            return true;
        }

        if (this.updatedTableData.comment.trim() === '') {
            alert('Comments are mandatory, please leave a comment.');
            return true;
        }
    };

    downloadText = (length: number) => `Click here Export the ${length} rows to a CSV file.`;

    getModal() {
        return (
          <>
              <div style={cssPropertiesTable}>
                  <Table isStriped={true}
                         getRowAttributes={this.getRowAttributes}
                         columns={getColumnsVariableStaffing}
                         aria-labelledby='heading'
                         renderCardForRow={renderCardForRowVS}
                         data={this.state.fetchedDataForTableRows}
                         actionHeader={!this.isReadOnly ? 'Edit' : ''}
                         spacing={TableSpacing.Default}
                         shouldAutoCollapseOnExpand={true} shouldScrollHorizontally={true} />
              </div>
              <Modal isScrollable={false} shouldCloseOnClickOutside={false} isOpen={this.state.isOpen}
                     close={this.close} aria-labelledby='Edit'>
                  <ModalContent
                    aria-label='Edit Message Details'
                    maxWidth={1050}
                    buttons={[
                        <Button
                          variant={ButtonVariant.Primary}
                          onClick={(event) => {
                              if (!this.checkValidEntry()) {
                                  this.close();
                                  this.handleSubmit(event);
                              }
                          }}
                          type='submit'> Submit </Button>,
                        <Button
                          onClick={() => {
                              this.close();
                              this.updatedTableData = {
                                  ConfigurationId: '',
                                  Frontline: '',
                                  Vendor1: '',
                                  Vendor2: '',
                                  comment: ''
                              };
                          }}
                          key='Close'
                          isDestructive
                          icon={<IconCross aria-hidden={true} size={IconSize.ExtraSmall} />}
                          variant={ButtonVariant.Tertiary}>
                            Discard
                        </Button>
                    ]}>
                      <H2 id='Edit' fontSize='T400'> Edit Configuration : {this.tableData.ConfigurationId} </H2>
                      {modalInstructionsVS()}
                      <FormWrapper
                        padding='S400' maxWidth={650} width={650}>
                          <InputWrapper id='text-preview-1' labelText='Frontline %'
                                        footerText='Enter the new front line % here'>
                              {(textAreaProps) => <TextArea
                                onChange={(event) => {
                                    this.updatedTableData.Frontline = event.target.value.trim();
                                }}
                                defaultValue={this.tableData.Frontline}
                                {...textAreaProps} />}
                          </InputWrapper>
                          <InputWrapper id='text-preview-2' labelText='Vendor1 %'
                                        footerText='Enter the new vendor1 % here'>
                              {(textAreaProps) => <TextArea
                                onChange={(event) => {
                                    this.updatedTableData.Vendor1 = event.target.value.trim();
                                }}
                                defaultValue={this.tableData.Vendor1}
                                {...textAreaProps} />}
                          </InputWrapper>
                          <InputWrapper id='text-preview-3' labelText='Vendor2 %'
                                        footerText='Enter the new vendor2 % here'>
                              {(textAreaProps) => <TextArea
                                onChange={(event) => {
                                    this.updatedTableData.Vendor2 = event.target.value.trim();
                                }}
                                defaultValue={this.tableData.Vendor2}
                                {...textAreaProps} />}
                          </InputWrapper>
                          <InputWrapper id='text-preview-2'
                                        labelText='Comments: Why the changes were made?'
                                        footerText='Ex: Changed Class M option 1 SMS to reflect new time-off regulations that went into place on 4/5.'>
                              {(textAreaProps) => <TextAreaWithRecommendedLength
                                resize='vertical'
                                recommendedWordCount={30}
                                defaultValue={this.tableData.comment}
                                onChange={(event) => {
                                    this.updatedTableData.comment = event.target.value.trim();
                                }}
                                {...textAreaProps} />}
                          </InputWrapper>
                      </FormWrapper>
                  </ModalContent>
              </Modal>
          </>
        );
    }

    getRowAttributes = () => ({
        onClick: ({ index }: any) => {
            this.setState({ isOpen: true });
            this.tableData.ConfigurationId = this.state.fetchedDataForTableRows[index].ConfigurationId;
            this.updatedTableData.ConfigurationId = this.tableData.ConfigurationId;

            this.tableData.Frontline = this.state.fetchedDataForTableRows[index].Frontline;
            this.updatedTableData.Frontline = this.tableData.Frontline;

            this.tableData.Vendor1 = this.state.fetchedDataForTableRows[index].Vendor1;
            this.updatedTableData.Vendor1 = this.tableData.Vendor1;

            this.tableData.Vendor2 = this.state.fetchedDataForTableRows[index].Vendor2;
            this.updatedTableData.Vendor2 = this.tableData.Vendor2;
        },
        disabled: this.isReadOnly
    });

    render() {

        if (!authService.isUserAuthenticated() && this.federateToken === null)
            return <SignedOut allowance={true} />;

        if (this.state.readyToRedirect) {
            return <SignedOut allowance={true} />;
        }

        if (!containsLdapElement(this.federateToken.LDAPGROUP, LDAP[3].toString())) {
            return <Forbidden federateToken={this.federateToken} allowance={true} />;
        }

        return (
          <StencilProvider theme={{
              ...HR2021Theme
          }}>
              <View height={150}>
                  <CustomHeader federateToken={this.federateToken} />
                  <Col margin={{ left: 155 }}>
                      {
                          authService.isTokenPresent() &&
                          <div className='link-underline'>
                            <Avatar
                              imageAltText='badge image'
                              fullName={this.federateToken.FAMILY_NAME + ', ' + this.federateToken.GIVEN_NAME}
                              username={this.federateToken.sub}
                              usernameClickable={true}
                              margin={25}>
                              <AvatarText ariaLabel="description">
                                You are accessing this page as {this.isReadOnly ? 'a Read-Only' : 'an Admin'} user.
                              </AvatarText>
                            </Avatar>
                          </div>
                      }
                  </Col>
              </View>
              <PageContainer
                backgroundColor='primary05'
                alignItems='center'
                centered={true}
                paddingBottom='S700'
                paddingTop='S600'
                paddingHorizontal='S600'>
                  {
                      this.state.isPostSuccess &&
                      <MessageBanner iconAltText='Successful' type={MessageBannerType.Success}
                                     title='Update successful'
                                     isDismissible onDismissed={() => {
                          this.setState({ isPostSuccess: false });
                          this.configurationSelected = '';
                      }}>
                        The {this.configurationSelected} entry is updated successfully.
                      </MessageBanner>
                  }
                  {
                      this.state.isPostError !== '' &&
                      <MessageBanner iconAltText='Failure' type={MessageBannerType.Error}
                                     title='Update failed' isDismissible
                                     onDismissed={() => this.setState({ isPostError: '' })}>
                        There seems to be an issue with the update - {this.state.isPostError}
                      </MessageBanner>
                  }
                  <br />
                  <MainWithSkipLink>
                      <Col gridGap='S500' padding='S300'>
                          <H1 id='heading' textAlign='center'> Variable Staffing </H1>
                          <Col alignItems='center'>
                              <TabBar
                                aria-label='Tabs here for Main Content and Audit trails'
                                layout={TabsLayout.Default}
                                onTabSelect={(tabValue) => {
                                    this.setState({ tabValue: tabValue });
                                    if (tabValue === tabs[1]) {
                                        this.setState({ selectedPage: 1, isExpanded: false });
                                        this.getTableDataForChangelog(true, 1, this.state.startDate, this.state.endDate);
                                    }
                                }}
                                selectedTab={this.state.tabValue}
                                tabGroup='TabGroup-1'
                                tabs={tabs}
                              />
                          </Col>
                          <TabSwitcher
                            selectedTab={this.state.tabValue}
                            tabGroup='TabGroup-1'>

                              <TabPanel value='Main Content'>
                                  <br />
                                  {
                                      this.state.loading &&
                                      <StencilProvider theme={{
                                          ...HR2021Theme
                                      }}>
                                        <br />
                                        <Col gridGap={35} aria-live='assertive' aria-busy={this.state.loading}>
                                          <Spinner size={70} strokeWidth={9} showText textColor='neutral100'
                                                   aria-live='assertive' aria-busy={this.state.loading} />
                                        </Col>
                                        <br />
                                      </StencilProvider>
                                  }
                                  <br />
                                  <Col
                                    backgroundColor='primary05'
                                    alignItems='center'
                                    justifyContent='center'>
                                      <ScreenReaderOnly>
                                          <Label htmlFor='Choose-Group' id='Choose-Group-label'>
                                              Choose Group from Dropdown
                                          </Label>
                                      </ScreenReaderOnly>
                                      <Select
                                        aria-label='Choose Group from Dropdown'
                                        searchFieldAriaLabel='Choose Group from Dropdown'
                                        id='Choose-Group'
                                        labelId='Choose-Group-label'
                                        placeholder='Choose Group'
                                        isSearchable={true}
                                        width={'30vw'}
                                        options={this.state.fetchedDataForDropdown}
                                        onChange={value => {
                                            this.getTableData(value);
                                            this.showNumberOfRows = true;
                                            this.configuration = value;
                                        }}
                                      />
                                      <br />
                                      <br />
                                      {
                                          this.showNumberOfRows &&
                                          <Text fontSize='T200'>Fetched no. of
                                            Rows: {this.state.fetchedDataForTableRows.length}</Text>
                                      }
                                      <br />
                                      {this.getModal()}
                                      <br />
                                  </Col>
                              </TabPanel>

                              <TabPanel value='Audit Trails'>
                                  <Expander
                                    isExpanded={this.state.isExpanded}
                                    onToggle={() => this.setState({ isExpanded: !this.state.isExpanded })}
                                    titleText='Click to open Filters'>
                                      <View backgroundColor='neutral0' alignItems='flex-start'
                                            padding='S300' flexWrap='overflow'>
                                          <Row gridGap='S700' justifyContent='flex-start' flexWrap='wrap'
                                               padding='S300'>
                                              <Col gridGap='S300' alignItems='flex-start' padding='S300'>
                                                  <Text id='smsType-cl3-selector-label'>
                                                      Choose Date Range to filter:
                                                  </Text>

                                                  <View width='55vw' justifyContent='flex-start'>
                                                      <PopupDateRangePicker
                                                        ariaLabelsForSelectedDate={{
                                                            endDate: 'You have selected an end date',
                                                            startDate: 'You have selected a start date'
                                                        }}
                                                        id='filter-date-picker'
                                                        name='choose-dates'
                                                        shouldFocusOnStartDate={true}
                                                        locale='iso8601'
                                                        startDateLabelText='Start date (YYYY-MM-DD)'
                                                        endDateLabelText='End date (YYYY-MM-DD)'
                                                        startValue={this.state.startDate as unknown as string}
                                                        endValue={this.state.endDate as unknown as string}
                                                        onChange={(startDate, endDate) => {
                                                            if (startDate)
                                                                this.setState({ startDate: startDate + ' 00:00:00' });
                                                            else
                                                                this.setState({ startDate: '' });
                                                            if (endDate)
                                                                this.setState({ endDate: endDate + ' 23:59:59' });
                                                            else
                                                                this.setState({ endDate: '' });
                                                        }}
                                                      />
                                                  </View>
                                              </Col>
                                          </Row>

                                          <Row gridGap='S700' padding='S600' justifyContent='center'
                                               flexWrap='wrap'>
                                              <Button
                                                variant={ButtonVariant.Primary}
                                                type='button'
                                                aria-describedby='smsType-cl1-selector-label'
                                                icon={<IconArrowRight title='Apply Filter' aria-hidden={true} />}
                                                iconPosition={ButtonIconPosition.Trailing}
                                                onClick={() => {
                                                    this.filters = this.valueOfAT;
                                                    this.getTableDataForChangelog(true, 1, this.state.startDate, this.state.endDate);
                                                    this.setState({ selectedPage: 1 });
                                                }}>
                                                  Apply Filter
                                                  &nbsp;
                                              </Button>
                                              <Button
                                                variant={ButtonVariant.Primary}
                                                type='button'
                                                icon={<IconReset title='Reset Filter' aria-hidden={true} />}
                                                iconPosition={ButtonIconPosition.Trailing}
                                                onClick={() => {
                                                    this.setState({
                                                        selectedPage: 1,
                                                        startDate: '',
                                                        endDate: ''
                                                    });
                                                    this.getTableDataForChangelog(true, 1, this.state.startDate, this.state.endDate);
                                                }}>
                                                  Reset Filters
                                                  &nbsp;
                                              </Button>
                                          </Row>
                                      </View>
                                  </Expander>
                                  <br />
                                  <Col
                                    backgroundColor='primary05'
                                    alignItems='center'
                                    justifyContent='center'>
                                      {
                                          this.state.loading &&
                                          <StencilProvider theme={{
                                              ...HR2021Theme
                                          }}>
                                            <br />
                                            <Col gridGap={35} aria-live='assertive' aria-busy={this.state.loading}>
                                              <Spinner size={70} strokeWidth={9} showText textColor='neutral100'
                                                       aria-live='assertive' aria-busy={this.state.loading} />
                                            </Col>
                                            <br />
                                          </StencilProvider>
                                      }
                                      <br />
                                  </Col>
                                  <Row gridGap='S500' display='flex' alignItems='flex-end' justifyContent='flex-end'
                                       padding='S300'>
                                      <Text margin={{ bottom: 7 }} fontWeight='bold' textAlign='right' fontSize='T200'>Total no. of
                                          Rows: {this.totalCount}</Text>
                                      {
                                          this.state.fetchedChangelogData.length !== 0 &&
                                          <ButtonWithTooltip
                                            role='tooltip'
                                            aria-describedby='Click here to Export the changelogs to CSV.'
                                            icon={<IconDownload title='Export to CSV' />}
                                            title={this.downloadText(this.totalCount)}
                                            variant={ButtonVariant.Secondary}
                                            onClick={() => {
                                                this.getChangelogCSV(true, this.state.startDate, this.state.endDate);
                                            }}
                                            tooltipAlignment={TooltipAlignment.Left}
                                            tooltipPosition={TOOLTIP_POSITION.BOTTOM}
                                            size={ButtonSize.Small}
                                            tooltipText={this.downloadText(this.totalCount)}
                                          >
                                            Download Changelog
                                          </ButtonWithTooltip>
                                      }
                                      <Spacer flex={0.20} />
                                      {
                                          this.state.fetchedChangelogData.length !== 0 &&
                                          <Pagination
                                            aria-label='pagination'
                                            numberOfPages={Math.ceil(this.totalCount / 10)}
                                            selectedPage={this.state.selectedPage}
                                            onPageSelect={(value) => {
                                                this.setState({ selectedPage: value });
                                                this.getTableDataForChangelog(true, value, this.state.startDate, this.state.endDate);
                                            }}
                                          />
                                      }
                                  </Row>
                                  <br />
                                  <div style={cssPropertiesTable}>
                                      <Table
                                        aria-labelledby='smsType-cl1-selector-label'
                                        actionHeader={'Expand'}
                                        getRowAttributes={getRowAttributesCLForVS}
                                        columns={getColumnsVariableStaffingChangeLog}
                                        renderCardForRow={renderCardForChanglelogVS}
                                        data={this.state.fetchedChangelogData}
                                        spacing={TableSpacing.Default}
                                        shouldAutoCollapseOnExpand={true}
                                        shouldScrollHorizontally={true} />
                                  </div>
                                  <br />
                              </TabPanel>
                          </TabSwitcher>
                      </Col>
                  </MainWithSkipLink>
                  <br />
                  <CustomBackToTop />
              </PageContainer>
              <CustomFooter />
          </StencilProvider>
        );
    }
}
